/* eslint-disable class-methods-use-this */
import axios from "axios";

import {API_STATION_URL, COMMON_HEADER_CONFIG} from "../config";

class CounterService {
  getAccessToken = () => localStorage.getItem("accessToken");

  searchCounters = (data = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_STATION_URL}/station-counters`,
        params: {
          ...data,
          size: 100,
          page: 1
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  addCounterToStation = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "post",
        url: `${API_STATION_URL}/station-counters`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateCounter = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "put",
        url: `${API_STATION_URL}/station-counters/${data.id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  deleteCounter = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "delete",
        url: `${API_STATION_URL}/station-counters/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.message);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const counterService = new CounterService();

export default counterService;
